"use client";

import React from 'react';
import { cn } from '@/lib/utils/cn';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function Logo({ className, width = 106, height = 104 }: LogoProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 106 104" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={cn("", className)}
    >
      <path 
        d="M105.993 52.3882C106.191 42.0504 100.293 30.9139 86.4992 26.2642H105.859C106.402 11.5131 92.8387 -0.658554 79.2789 0.133586V20.433C74.9621 7.40929 66.3889 0.0537065 52.9966 0.037065C39.6478 0.0204234 31.0746 7.34605 26.6506 19.7507V0.000453437C9.52092 -0.0960678 -0.94446 15.2375 0.247756 26.3574H19.8758C7.87659 30.4779 0.596043 38.3327 0.0937055 50.7141C-0.458866 64.3302 6.92885 73.0205 20.0131 77.6701H0.11045C-1.47694 90.6273 14.6079 106.347 26.721 103.708V83.6511C30.7564 95.7862 38.5862 103.102 51.0944 103.814C65.3775 104.63 74.5134 97.2772 79.3358 84.1071V103.817C91.7369 104.53 106.043 93.8358 105.953 77.5936H86.2447C98.0563 74.0689 105.772 64.227 106 52.3882H105.993ZM26.7779 26.4539H46.0878C36.1247 29.5626 29.8154 35.8931 26.7779 45.4853V26.4539ZM26.8516 77.557V58.0197C29.9058 68.1844 36.2721 74.4683 46.3925 77.557H26.8516ZM79.1416 26.3774V45.9712C76.151 35.9563 69.8651 29.5859 60.3039 26.3774H79.1416ZM79.1918 77.5303H59.6777C69.8216 74.4483 76.2146 68.0047 79.1918 57.7135V77.5303Z" 
        fill="white"
      />
    </svg>
  );
}